export const FREQUENCIA_OPTIONS = [
  { value: '1', label: 'Diário' },
  { value: '7', label: 'Semanal' },
  { value: '30', label: 'Mensal' },
  { value: '31', label: 'Único' },
] as const;

export const WEEKDAY_OPTIONS = [
  { value: 'Seg', label: 'Segunda' },
  { value: 'Ter', label: 'Terça' },
  { value: 'Qua', label: 'Quarta' },
  { value: 'Qui', label: 'Quinta' },
  { value: 'Sex', label: 'Sexta' },
  { value: 'Sab', label: 'Sábado' },
  { value: 'Dom', label: 'Domingo' },
] as const;

export const ATIVIDADE_OPTIONS = [
  { value: '', label: 'Selecione' },
  { value: '1', label: '1-30 dias' },
  { value: '30', label: '30-59 dias' },
  { value: '60', label: '60-89 dias' },
  { value: '>', label: '>90 dias' },
] as const;

export const FAIXA_ETARIA_OPTIONS = [
  { value: '', label: 'Selecione' },
  { value: '17', label: '<= 18' },
  { value: '18', label: '> 18' },
  { value: '25', label: '18-25' },
  { value: '35', label: '26-35' },
  { value: '40', label: '36-40' },
  { value: '45', label: '40-45' },
  { value: '46', label: '>45' },
] as const;

export const GENERO_OPTIONS = [
  { value: '', label: 'Selecione' },
  { value: 'M', label: 'Masculino' },
  { value: 'F', label: 'Feminino' },
  { value: 'O', label: 'Outros' },
  { value: 'P', label: 'Prefiro não dizer' },
] as const;

export const PERFORMANCE_OPTIONS = [3, 7, 14, 21, 30] as const;

export const GEO_PASSBOOK_IDS = new Set(['66b289d517e4669d041c8304', '65b14fa10142472d1519d0b7']);

export function defaultAutomatedPayload(): import('@/shared/types/campaign').AutomatedCampaignPayload {
  return {
    action: 'insert',
    ativo: true,
    nome: '',
    tipo_campanha: 'C',
    tipo_disparo: 'push',
    frequencia: '1',
    frequencia_dia: '',
    frequencia_unico: '',
    frequencia_horas: '',
    frequencia_dia_semana: '',
    expirar: false,
    dt_inicio: '',
    dt_fim: '',
    performance: 3,
    // 'all' (não '') — o backend (`/user/filter`) só conta os elegiveis/instalados
    // quando `plataforma` é truthy; vazio cai num branch que retorna 0 fixo.
    plataforma: 'all',
    atividade: '',
    faixa_etaria: '',
    genero: '',
    description: '',
    mais_informacao: '',
    stores: '',
    state: '',
    city: '',
    clusters_data: '[]',
    valor_de: '',
    valor_ate: '',
  };
}
